import { render, staticRenderFns } from "./DossierAlert.vue?vue&type=template&id=8d9919ae&"
import script from "./DossierAlert.vue?vue&type=script&lang=ts&"
export * from "./DossierAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports